module.exports = __webpack_public_path__ + "media/images/emblems/Alle-coat_of_arms-e542faf08a3978e4580a0dc8dde31469.svg";